import React from 'react';
import './App.css';
import Pong from './components/Pong';
import ProfilePage from './components/ProfilePage';

function App() {
  return (
    <div style={{ backgroundColor: '#1a1a1a', minHeight: '100vh' }}>
      <ProfilePage />
    </div>
  );
}

export default App; 